import css from 'styled-jsx/css';

const styles = css.global`.offer-carousel-modal{position:fixed;width:100%;bottom:0;background:#fff;z-index:2000;padding:16px;box-shadow:0 -3px 5px 0 rgba(0,0,0,.1333333333)}.offer-carousel-modal .close-btn{position:absolute;top:-16px;right:8px;background:#004198;color:#fff;padding:5px;font-weight:bold;border-radius:20px;font-size:14px}`;

export default styles;